import { environment } from "src/environments/environment";
import { wrapFunction } from "./Profile.schema";

export function ProfileMethod({ threshold = 0, color = null } = {}): any {
  return (
    classPrototype: any,
    propertyName: string,
    descriptor: PropertyDescriptor,
  ) => {
    if (environment.production) {
      return;
    }
    // Wrap the method for timing
    const originalMethod: Function = descriptor.value;
    descriptor.value = wrapFunction(originalMethod, {
      context: classPrototype.constructor.name,
      threshold,
      color,
    });

    // Replace the method on the class
    Object.defineProperty(classPrototype, propertyName, descriptor);
  };
}
